import { render } from "./TenantUsers.vue?vue&type=template&id=164c61c0&ts=true"
import script from "./TenantUsers.vue?vue&type=script&lang=ts"
export * from "./TenantUsers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__